const backendSkills = [
  {
    id: 1,
    title: 'Node.js',

    img1: '/images/skillsImages/backend/node-js.png',
  },
  {
    id: 2,
    title: 'Express.js',
    img1: '/images/skillsImages/backend/expressjs.png',
  },
  {
    id: 3,
    title: 'Nest.js',
    img1: '/images/skillsImages/backend/nest-js.png',
  },
  {
    id: 4,
    title: 'C#',
    img1: '/images/skillsImages/backend/c-sharp.png',
  },
  {
    id: 5,
    title: '.NET',
    img1: '/images/skillsImages/backend/dotnet.png',
  },
  {
    id: 6,
    title: 'Hapi',
    img1: '/images/skillsImages/backend/hapi.png',
  },
  {
    id: 7,
    title: 'MongoDB',
    img1: '/images/skillsImages/backend/mongodb.png',
  },
  {
    id: 8,
    title: 'Mongoose',
    img1: '/images/skillsImages/backend/mongoose.png',
  },
  {
    id: 9,
    title: 'Heroku',
    img1: '/images/skillsImages/backend/heroku.png',
  },
  {
    id: 10,
    title: 'REST API',
    img1: '/images/skillsImages/backend/rest-api.jpg',
  },
  {
    id: 11,
    title: 'FastAPI',
    img1: '/images/skillsImages/backend/FastAPI.png',
  },
  {
    id: 12,
    title: 'GraphQL',
    img1: '/images/skillsImages/backend/graphql.png',
  },
  {
    id: 13,
    title: 'Swagger',
    img1: '/images/skillsImages/backend/swagger.png',
  },
  {
    id: 14,
    title: 'Mocha',
    img1: '/images/skillsImages/backend/mocha.png',
  },
  {
    id: 15,
    title: 'Chai',
    img1: '/images/skillsImages/backend/chai.png',
  },
  // {
  //   id: 12,
  //   title: 'JWT',
  //   img1: '/images/skillsImages/backend/jwt.png',
  // },
];

export default backendSkills;
